__turbopack_context__.v({
  "cornerClose": "TasksSignUpDialog-module-scss-module__LLX7iG__cornerClose",
  "cornerIcon": "TasksSignUpDialog-module-scss-module__LLX7iG__cornerIcon",
  "description": "TasksSignUpDialog-module-scss-module__LLX7iG__description",
  "descriptionLine": "TasksSignUpDialog-module-scss-module__LLX7iG__descriptionLine",
  "dialog": "TasksSignUpDialog-module-scss-module__LLX7iG__dialog",
  "inner": "TasksSignUpDialog-module-scss-module__LLX7iG__inner",
  "primaryBtn": "TasksSignUpDialog-module-scss-module__LLX7iG__primaryBtn",
  "title": "TasksSignUpDialog-module-scss-module__LLX7iG__title",
});
